import Banner from '../common/Banner';
import { getLocalizedString } from '../../utils/i18n-utils';

const RELEASE_NOTES_URL = 'https://help.athenahealth.com/alpha-beta/Content/RelNote-Alpha-Beta/Plat_PasskeysFIDO2ForaOne_FEATURE27045.htm';

export default function NewFactorAvailableBanner() {
  return (
    <Banner alertType='new' headerText={getLocalizedString('webauthn.new.factor.banner.header')}>
      {getLocalizedString('webauthn.new.factor.banner.body')}
      <a href={RELEASE_NOTES_URL} className="inline-link" target="_blank" rel="noopener noreferrer">
        {getLocalizedString('webauthn.new.factor.banner.link')}
      </a>
    </Banner>
  );
}
